export const desnake = function() {
  return function(input) {
    return input.replace(/\_/g, ' ');
  };
};
